module.exports = __webpack_public_path__ + "static/media/slider8.26515671.webp";